<h1 mat-dialog-title class="generic-dialog-title">{{ data.genericTitle }}</h1>
<div mat-dialog-content class="generic-dialog-content">
    <p class="generic-dialog-text" [innerHTML]="data.genericContent"></p>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button (click)="close()" cdkFocusInitial>Ok</button>
</div>
